import {
  Form,
  Button
} from 'react-bootstrap'
import { NextPage } from 'next'
import React, { useState, useEffect, useRef } from 'react'
import { withI18n } from '~/hocs'
import { AppCommonProps } from 'types/app'
import dynamic from 'next/dynamic'
const Picker = dynamic(() => import('emoji-picker-react'), { ssr: false })
import _ from 'lodash'
import config from '~/config'
import { getAvatar, redirectLogin } from '~/utils'
import { signIn, useSession } from 'next-auth/react'
import { routes } from '~/router'
import CommentItemVideo from './CommentItemVideo'

const CommentVideo: NextPage<AppCommonProps> = ({
  t, lng, video, isLoadingComment, onHandleUpdate, onHandleDelete,
  onHandleHide, comments, setComments, onHandleComment, profile, commentsOfCreator,
  limit, setLimit, totalComments, replies, setReplies, onHandleReply, showPicker, setShowPicker, height, setHeight, onEmojiClick, wrapperRef
}: any) => {
  const { data: session } = useSession()
  const { data: nextAuthSession, status: nextAuthStatus } = useSession()
  return (
    <>
      <div className="ac-section-title ac-mb-1 mt-2">
        <h1>素敵な無料動画を提供してくれた「{video?.user?.nickname || video?.user?.email.substring(0, 1) + '*****' + video?.user?.email.substring(video?.user?.email.length - 1, video?.user?.email.length)}」さんに応援のコメントを贈ろう！</h1>
      </div>
      <div className="alert ac-alert d-flex align-items-center justify-content-between alert-warning alert-dismissible fade show border-right-0 border-top-0 border-bottom-0 border-left border-warning border-width-4 ac-mb-3" role="alert">
        <div className="flex-grow-1 d-flex align-items-center"><i className="fa fa-exclamation-circle ac-mr-2 text-warning" aria-hidden="true"></i>
          <div className="flex-grow-1">
            <p className="m-0">素材の使用範囲や、使用方法など動画ACへのお問い合せについては、こちらの<a href="https://help.freebie-ac.jp/tag/4/%E4%BD%BF%E7%94%A8%E6%96%B9%E6%B3%95%E3%83%BB%E5%88%A9%E7%94%A8%E7%AF%84%E5%9B%B2" target="_blank" className="ac-text-blue">ヘルプセンター</a>をご確認ください。</p>
          </div>
        </div>
      </div>
      {
        profile.email ? <div className='position-relative'>
          <div className="d-flex align-items-center">
            <img className="mr-2 align-self-start" src={nextAuthSession ? (nextAuthSession.user?.avatar?.substring(0, 8) == 'property' ? `${config.assetPrefix}/${nextAuthSession.user?.avatar}` : (nextAuthSession.user?.avatar ? nextAuthSession.user?.avatar
              : `${process.env.ASSET_PREFIX}/asset/image/creator/avatar/0-0${1}.jpg`)) : (getAvatar(profile))} alt="avatar" width="50" />
            <span>
              {nextAuthSession ? (
                nextAuthSession.user?.nickname ? (
                  <>
                    {nextAuthSession.user?.nickname.length < 20
                      ? `${nextAuthSession.user?.nickname}`
                      : `${nextAuthSession.user?.nickname.substring(0, 20)}...`}
                  </>
                ) : (
                  <>
                    {`${nextAuthSession.user?.email.substring(0, 1)}**********${nextAuthSession.user?.email.substring(
                      nextAuthSession.user?.email.length - 1,
                      nextAuthSession.user?.email.length
                    )
                      }`}
                  </>
                )
              ) : profile.nick_name ? (
                <>{profile.nick_name}</>
              ) : (
                <>
                  {`${profile.email.substring(0, 1)}*****${profile?.email.substring(
                    profile?.email.length - 1,
                    profile?.email.length
                  )}`}
                </>
              )}
              さん
            </span>
          </div>
          <div className="mt-2 mb-2">
            <div className="picker-container" ref={wrapperRef} id="section-comment">
              <Form.Control as="textarea" className="text-area-comment" placeholder="コメントする" style={{ height, overflowY: "hidden" }} value={comments.content}
                onChange={(e) => {
                  setComments({
                    ...comments,
                    content: e.target.value
                  })
                  const lines = e.target.value.split('\n')
                  if (lines[lines.length - 1].match(/^\s*$/) && lines.length > 1) {
                    setHeight(`${e.target.scrollHeight - 11}px`)
                  } else if (lines.length === 1) {
                    setHeight('39px')
                  } else {
                    setHeight(`${e.target.scrollHeight}px`)
                  }
                }} />
              <div className="emoji-container">
                <img
                  className="emoji-icon"
                  alt="true"
                  src="https://icons.getbootstrap.com/assets/icons/emoji-smile.svg"
                  onClick={(e) => {
                    setShowPicker((val) => !val)
                  }}
                />
                <Button variant="primary" type="button" className="ac-btn-sm rounded-left-0 ml-4 button-comment" disabled={isLoadingComment} onClick={onHandleComment} >
                  送信
                </Button>
              </div>
              {showPicker && (
                <Picker pickerStyle={{ width: "100%" }} onEmojiClick={onEmojiClick} />
              )}
            </div>
            <div id="loading-wrapper" className="list-video-wrapper" style={{ position: 'relative', minHeight: '30px' }}>
              <div className="loading-wrapper" style={{ display: isLoadingComment ? 'flex' : 'none' }}>
                <div id="loading-spin" className="spinner-border text-secondary " role="status"
                  style={{ marginTop: "0px" }}
                >
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
              {
                commentsOfCreator.map((item, index) => {
                  return <div className='mt-1'>
                    <CommentItemVideo item={item} key={item.id} profile={profile}
                      isLoadingComment={isLoadingComment} setReplies={setReplies}
                      replies={replies} onHandleReply={onHandleReply} onHandleUpdate={onHandleUpdate} onHandleDelete={onHandleDelete}
                      onHandleHide={onHandleHide} videoUserID={video?.user.id} session={session}
                    />
                  </div>
                })
              }
              <div className="button-load-more-comment mb-5 text-center">
                {commentsOfCreator && commentsOfCreator.length >= 15 && commentsOfCreator.length < totalComments && <Button variant="primary" onClick={() => {
                  if (limit < totalComments) {
                    setLimit(limit + 10)
                  }
                }}>コメントをもっと見る</Button>}
              </div>
            </div>
          </div>
        </div> : <div className="ac-mb-3">コメントするには<a onClick={() => redirectLogin(lng)} title="ログイン"
          className="ac-text-blue">ダウンロードユーザーログイン</a>、もしくは
          <a className="ac-text-blue" onClick={() => signIn(undefined, { callbackUrl: routes.creator.dashboard.href })}>クリエイターログイン</a>が必要です。
        </div>
      }
    </>
  )
}


export default withI18n(CommentVideo)
